export enum MobileAppPayloadTypeEnum {
  session,
  navigation,
  error,
}

export enum MobileAppPayloadNavigateToEnum {
  login,
  emailConfirmation,
  close,
}
